import { render, staticRenderFns } from "./FechaInicioFin.vue?vue&type=template&id=ffb44530&scoped=true&"
import script from "./FechaInicioFin.vue?vue&type=script&lang=js&"
export * from "./FechaInicioFin.vue?vue&type=script&lang=js&"
import style0 from "./FechaInicioFin.vue?vue&type=style&index=0&id=ffb44530&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb44530",
  null
  
)

export default component.exports